<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <span id="log"></span> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      screenWidth:window.innerWidth,
      screenHeight:window.innerHeight,
      res:{},
    }
  },
  created(){
    // this.shareUrl = window.location.protocol+"//"+window.location.hostname +"/";
    console.log(this.shareUrl)
      let goUrl = this.isMobile();
     var code = this.getUrlKey("code")
      console.log( code)
    if (goUrl === 1) {
       //移动端地址

         var name = this.$route.name
         if(name == 'pchome' || name == 'recharge'){
                    this.$router.push({name:'h5home',query: {code: code}})    
         }else{
           this.$router.push({name:name?name:'h5home',query: {code: code}})    
         }
        
    }else{
         console.log(this.$route.name)
         var name = this.$route.name
             if(name == 'h5home'|| name == 'h5recharge'){
                    this.$router.push({name:'pchome',query: {code: code}})    
         }else{
         this.$router.push({name:name?name:'pchome',query: {code: code}})
         }
        
      

    }

    
  
  
  },

  methods:{

    isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        localStorage.setItem('isiphone',flag)
        localStorage.setItem('ismobile',flag?1:0);
        let goUrl = flag ? 1 : 0;
        return goUrl;
    },
         getUrlKey(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },

  
  }
}
</script>

<style  lang="less">
// #app {
//   width: 100%; height: 100%;
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   position: relative;
//   /* margin-top: 60px; */
//   #log{
//             display: block; 
//             width: 9.2%; height: 7%; 
//             position: absolute; background: url("http://lianai-image-sys.imlianai.com/19_3_23/logo.png"); 
//             background-size: 100% 100%; left: 20%; top: 4%;
//             z-index: 2;
//         }
// }

</style>



// WEBPACK FOOTER //
// src/App.vue